import { SlidersHorizontal } from "lucide-react";
import { Button } from "../../client/components/ui/button";
import { Input } from "../../client/components/ui/input";
import { Label } from "../../client/components/ui/label";
import { Popover, PopoverContent, PopoverTrigger } from "../../client/components/ui/popover";
import useTranslation from "../../client/hooks/useTranslation";

export default function TopbarPnlFilterWidget({
  minPnl,
  maxPnl,
  onMinChange,
  onMaxChange,
}: {
  minPnl: string;
  maxPnl: string;
  onMinChange: (v: string) => void;
  onMaxChange: (v: string) => void;
}) {
  const t = useTranslation();
  const active = minPnl !== "" || maxPnl !== "";
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" size="sm" className="h-9 text-sm gap-1.5">
          <SlidersHorizontal className="h-3.5 w-3.5" />
          {t.journal.pnlFilterLabel}
          {active && <span className="ml-1 h-1.5 w-1.5 rounded-full bg-primary" />}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-64 space-y-3" align="end">
        <div className="space-y-1.5">
          <Label className="text-xs">{t.journal.minPnlLabel}</Label>
          <Input type="number" value={minPnl} onChange={(e) => onMinChange(e.target.value)} placeholder="0.00" className="h-9" />
        </div>
        <div className="space-y-1.5">
          <Label className="text-xs">{t.journal.maxPnlLabel}</Label>
          <Input type="number" value={maxPnl} onChange={(e) => onMaxChange(e.target.value)} placeholder="0.00" className="h-9" />
        </div>
      </PopoverContent>
    </Popover>
  );
}
